export function dataGridLocale(t: any, i18n: any) {
    const lacalText = {
        toolbarColumns: t('dataGrid.toolbarColumns'),
        toolbarFilters: t('dataGrid.toolbarFilters'),
        toolbarExport: t('dataGrid.toolbarExport'),
        filterOperatorContains: t('dataGrid.filterOperatorContains'),
        filterOperatorEquals: t('dataGrid.filterOperatorEquals'),
        filterOperatorStartsWith: t('dataGrid.filterOperatorStartsWith'),
        filterOperatorEndsWith: t('dataGrid.filterOperatorEndsWith'),
        filterOperatorIs: t('dataGrid.filterOperatorIs'),
        filterOperatorNot: t('dataGrid.filterOperatorNot'),
        filterOperatorAfter: t('dataGrid.filterOperatorAfter'),
        filterOperatorOnOrAfter:  t('dataGrid.filterOperatorOnOrAfter'),
        filterOperatorBefore: t('dataGrid.filterOperatorBefore'),
        filterOperatorOnOrBefore:  t('dataGrid.filterOperatorOnOrBefore'),
        filterOperatorIsEmpty: t('dataGrid.filterOperatorIsEmpty'),
        filterOperatorIsNotEmpty:  t('dataGrid.filterOperatorIsNotEmpty'),
        filterOperatorIsAnyOf:  t('dataGrid.filterOperatorIsAnyOf'),
        filterValueAny: t('dataGrid.filterValueAny'),
        filterValueTrue: t('dataGrid.filterValueTrue'),
        filterValueFalse: t('dataGrid.filterValueFalse'),
        columnsPanelTextFieldPlaceholder: t('dataGrid.columnsPanelTextFieldPlaceholder'),
        filterPanelInputPlaceholder: t('dataGrid.filterPanelInputPlaceholder'),
        toolbarQuickFilterPlaceholder: t('dataGrid.toolbarQuickFilterPlaceholder'),
        toolbarQuickFilterLabel: t('dataGrid.toolbarQuickFilterLabel'),
        toolbarQuickFilterDeleteIconLabel: t('dataGrid.toolbarQuickFilterDeleteIconLabel'),
        columnMenuLabel: t('dataGrid.columnMenuLabel'),
        columnMenuShowColumns: t('dataGrid.columnMenuShowColumns'),
        columnMenuManageColumns: t('dataGrid.columnMenuManageColumns'),
        columnMenuFilter: t('dataGrid.columnMenuFilter'),
        columnMenuHideColumn: t('dataGrid.columnMenuHideColumn'),
        columnMenuUnsort: t('dataGrid.columnMenuUnsort'),
        columnMenuSortAsc: t('dataGrid.columnMenuSortAsc'),
        columnMenuSortDesc: t('dataGrid.columnMenuSortDesc'),
        pinToLeft: t('dataGrid.pinToLeft'),
        pinToRight: t('dataGrid.pinToRight'),
        unpin: t('dataGrid.unpin'),
        groupColumn: (name: any) => t('dataGrid.groupBy', {name: name}),
        filterPanelAddFilter: t('dataGrid.filterPanelAddFilter'),
        filterPanelRemoveAll: t('dataGrid.filterPanelRemoveAll'),
        filterPanelDeleteIconLabel: t('dataGrid.filterPanelDeleteIconLabel'),
        filterPanelLogicOperator: t('dataGrid.filterPanelLogicOperator'),
        filterPanelOperator: t('dataGrid.filterPanelOperator'),
        filterPanelOperatorAnd: t('dataGrid.filterPanelOperatorAnd'),
        filterPanelOperatorOr: t('dataGrid.filterPanelOperatorOr'),
        filterPanelColumns: t('dataGrid.filterPanelColumns'),
        filterPanelInputLabel: t('dataGrid.filterPanelInputLabel'),
        noRowsLabel: 'სია ცარიელია',
        columnsPanelTextFieldLabel: 'სვეტის ძებნა',
        columnsPanelShowAllButton: 'გამოაჩინე ყველა',
        columnsPanelHideAllButton: 'დამალე ყველა',
    }

    return lacalText;
}